module.exports = __webpack_public_path__ + "img/industri_paavirkning_vannuttak_hymo.bdf1c9e5.jpg";